import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User } from 'api/models';
import { Popover } from 'components/atoms/popover';
import { OrgNode } from '../types';
import { EditNodeAddReportees } from './EditNodeAddReportees';
import { EditNodeAddReportingTo } from './EditNodeAddReportingTo';

interface Props {
  // eslint-disable-next-line react/no-unused-prop-types
  user: User;
  parent: User | null;
  onComplete?: () => void;
  selected: OrgNode[];
}

const StyledHeaderSecondary = styled.div`
  color: var(--blue-60);
  padding: var(--spacing-05);
  padding-bottom: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const SecondaryDropdown = styled.div``;
const DropdownContainer = styled.div``;

const PrimaryDropdown = styled.div`
  & .ozone-select__menu-list {
    height: 190px;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const EditOrgNode = (props: Props) => {
  const { selected, user, parent, onComplete } = props;

  const [showSecondaryDropdown, setShowSecondaryDropdown] = useState(false);

  return (
    <Popover
      visible
      placement="bottom"
      content={
        <>
          <DropdownContainer>
            {!showSecondaryDropdown && (
              <PrimaryDropdown>
                <EditNodeAddReportees
                  userId={user.userId}
                  selected={selected}
                  onComplete={onComplete}
                />
              </PrimaryDropdown>
            )}
            {showSecondaryDropdown && (
              <SecondaryDropdown>
                <StyledHeaderSecondary
                  onClick={() => setShowSecondaryDropdown(false)}
                >
                  <FormattedMessage id="back" />
                </StyledHeaderSecondary>
                <EditNodeAddReportingTo
                  userId={user.userId}
                  selected={parent ?? null}
                  onComplete={() => setShowSecondaryDropdown(false)}
                />
              </SecondaryDropdown>
            )}
          </DropdownContainer>
        </>
      }
    >
      <span />
    </Popover>
  );
};
